// extracted by mini-css-extract-plugin
export var videoButton = "styles-module--videoButton--bda36";
export var videoContainer = "styles-module--videoContainer--53774";
export var videoCover = "styles-module--videoCover--b3549";